import { Record } from 'immutable';

export default class ActiveFontRecord extends Record({
  id: '',
  href: '',
  html: '',
}) {
  getFontHTMLAsObject() {
    const { href } = this;
    return { href, rel: 'stylesheet', type: 'text/css' };
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/records/ActiveFontRecord.js